"use client";

import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/theme";
import { useTranslation } from "@/lib/i18n";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <button
      onClick={toggleTheme}
      aria-label={t(theme === "dark" ? "theme.switchToLight" : "theme.switchToDark")}
      className="p-1 text-text-faint hover:text-mint-text transition-colors cursor-pointer"
    >
      {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
